import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => {
  return {
    buttonContainer: {
      marginTop: '8px',
      width: '100%',
    },
    container: {
      backgroundColor: '#F5F5F5',
      borderRadius: '6px',
      padding: '16px',
      [theme.breakpoints.up('md')]: {
        padding: '20px',
      },
    },
    listContainer: {
      color: theme.palette.primary.main,
      marginBottom: '0px',
      paddingLeft: '36px',
    },
    listItem: {
      color: theme.palette.primary.main,
    },
    responsiveButtonContainer: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        marginLeft: 'auto',
        width: '360px',
      },
    },
    responsiveFullWidth: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: 'auto',
      },
    },

    typographyCancelAnytime: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '12px',
      marginTop: '10px',
    },
    typographyListItem: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '20px',
    },
    typographyTitle: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      lineHeight: '22px',
      marginBottom: '0px',
    },
  };
});

export default ({ onSubsribeClick }) => {
  const classes = useStyles();

  const handleSubsribeButtonClick = () => {
    if (onSubsribeClick) onSubsribeClick();
  };

  return (
    <div className={classes.container}>
      <Grid container alignItems="center">
        <Grid item xs={12} md={7}>
          <Typography className={`${classes.typographyTitle} text-left`}>Premium Self-Help Tools & Content Available</Typography>
          <ul className={classes.listContainer}>
            <li className={classes.listItem}>
              <Typography className={`${classes.typographyListItem} text-left`}>Normal anatomy and illness/injury explanation videos</Typography>
            </li>
            <li className={classes.listItem}>
              <Typography className={`${classes.typographyListItem} text-left`}>Radiology jargon to everyday language translator</Typography>
            </li>
            <li className={classes.listItem}>
              <Typography className={`${classes.typographyListItem} text-left`}>3D models, art, and animations</Typography>
            </li>
          </ul>
        </Grid>

        <Grid item xs={12} md={5} className="text-right">
          <div className={classes.responsiveButtonContainer}>
            <LoadingButton className={classes.buttonContainer} variant="contained" color="primary" onClick={handleSubsribeButtonClick}>
              Premium Content ($19.00)
            </LoadingButton>
            <Typography align="center" className={classes.typographyCancelAnytime}>
              Lifetime access
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
